"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxLength = void 0;
const fields_1 = require("../../utils/fields");
const intl_1 = require("../../locale/intl");
const texts_1 = require("../../texts");
const validation_1 = require("../../validation/validation");
const maxLength = (field) => {
    const maxLengthValue = (0, fields_1.getMaxLength)(field);
    const validator = (value) => value && String(value).length > (maxLengthValue !== null && maxLengthValue !== void 0 ? maxLengthValue : 0)
        ? { max_length: true }
        : null;
    return {
        validator: maxLengthValue ? validator : validation_1.dummyValidator,
        message: (0, intl_1.$t)(texts_1.textFieldsText.maximum_characters_allowed),
    };
};
exports.maxLength = maxLength;
